import { createSelector } from '@reduxjs/toolkit';

import {
  locationName,
  TLocationSliceType,
} from '~/redux/slices/location/index';
import { TAppStore } from '~/redux/store/useAppDispatch';

export const locationPlainSelector = ({
  [locationName]: slice,
}: TAppStore): TLocationSliceType => slice;
export const previousPathSelector = createSelector(
  locationPlainSelector,
  ({ previousPath }) => previousPath,
);

export const routerPathsSelector = createSelector(
  locationPlainSelector,
  ({ routerPaths }) => routerPaths,
);

export const routeAfterLoginSelector = createSelector(
  locationPlainSelector,
  ({ routeAfterLogin }) => routeAfterLogin,
);
